module.exports = "https://cdn.dashboard.gifty.nl/5927/images/gifty-logo.png?352b361b8ca132b5af0f30d6d0287c0f";